// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3QITW","rightAdornment":"Header_rightAdornment__3gAb6"};